import { Dialog } from '@servicetitan/anvil2';
import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { providerIdToName } from '@servicetitan/financing-utils-shared';

export const ExternalApplicationHeader = () => {
    const { setupData } = SetupDataStore.useStore();
    const { applicationDialogHeading } = useProviderConfig();

    return (
        <Dialog.Header>
            {setupData?.provider && applicationDialogHeading
                ? applicationDialogHeading
                : `${providerIdToName(setupData?.provider ?? '')} Application`}
        </Dialog.Header>
    );
};
